import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

export const FormStyled = styled.form`
  position: relative;
  .field-group {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
    ${css.mobileMedia} {
      flex-direction: column;
      margin-bottom: 0;
      .field {
        margin-bottom: 1.5rem;
      }
    }
    .field {
      &:not(.checkbox) {
        display: flex;
        flex-direction: column;
        /* margin-right: 1rem; */
        width: 100%;
        &:last-child {
          margin-right: 0;
        }
        label {
          color: ${css.black};
          font-size: 1rem;
          .icon {
            position: relative;
            left: 0.25rem;
            top: 0.25rem;
            cursor: pointer;
          }
        }
        .input {
          input {
            width: 100%;
          }
        }
        .error {
          margin-top: 0.25rem;
          color: ${css.red2};
        }
      }
    }
  }
  .hidden-submit {
    display: none;
  }
  h3 {
    font-weight: bold;
  }
`;

interface FormProps {
  id?: string;
  onSubmit?(e: React.FormEvent<HTMLFormElement>): void;
  children: React.ReactNode;
  className?: string;
  submitInput?: boolean;
}

/** Form wrapper that prevents default submit and renders an optional hidden submit input. */
export const Form = (props: FormProps) => {
  return (
    <FormStyled id={props.id} onSubmit={(e: any) => { e.preventDefault(); e.stopPropagation(); props.onSubmit?.(e); return false; }} className={props.className || ''}>
      {props.children}
      {props.submitInput !== false && <input type="submit" className="hidden-submit" /> || null}
    </FormStyled>
  );
};